import { Search } from 'lucide-react';
import { RegionMultiSelect, RegionChips } from './region-multi-select';

interface AssignmentFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  regions: string[];
  onRegionsChange: (value: string[]) => void;
  status: string | undefined;
  onStatusChange: (value: string | undefined) => void;
  source: string | undefined;
  onSourceChange: (value: string | undefined) => void;
  sources: string[];
  language?: 'en' | 'sv';
}

export function AssignmentFilters({
  search,
  onSearchChange,
  regions,
  onRegionsChange,
  status,
  onStatusChange,
  source,
  onSourceChange,
  sources,
  language = 'sv'
}: AssignmentFiltersProps) {
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-3">
        <div className="relative min-w-[200px] flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search title, skills, company..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="h-9 w-full rounded-md border bg-background pl-9 pr-3 text-sm outline-none focus:ring-1 focus:ring-ring"
          />
        </div>

        <RegionMultiSelect selected={regions} onChange={onRegionsChange} language={language} />

        <select
          value={status ?? ''}
          onChange={(e) => onStatusChange(e.target.value || undefined)}
          className="h-9 rounded-md border bg-background px-3 text-sm outline-none focus:ring-1 focus:ring-ring"
        >
          <option value="">All statuses</option>
          <option value="active">Active</option>
          <option value="closed">Closed</option>
        </select>

        {sources.length > 1 && (
          <select
            value={source ?? ''}
            onChange={(e) => onSourceChange(e.target.value || undefined)}
            className="h-9 rounded-md border bg-background px-3 text-sm capitalize outline-none focus:ring-1 focus:ring-ring"
          >
            <option value="">All sources</option>
            {sources.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        )}
      </div>

      <RegionChips selected={regions} onChange={onRegionsChange} language={language} />
    </div>
  );
}
